export default __webpack_public_path__ + "static/media/6.3231c950.jpg";